const KEY = "brox-consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveConsent({ analytics }) {
  const value = { essential: true, analytics: Boolean(analytics), ts: new Date().toISOString() };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {}
  window.dispatchEvent(new CustomEvent("brox-consent-change", { detail: value }));
  return value;
}

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent("brox-open-cookie-settings"));
}

export function initGa4() {
  const id = process.env.REACT_APP_GA4_ID;
  if (!id || window.__ga4) return false;
  window.__ga4 = id;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
  return true;
}

export function applyGa4Consent(consent) {
  if (!window.gtag) return;
  window.gtag("consent", "update", {
    analytics_storage: consent?.analytics ? "granted" : "denied",
  });
}
